import { combineReducers } from '@reduxjs/toolkit';
import authSlice from './slices/auth/authSlice';
import appointmentSlice from './slices/scheduler/appointmentSlice';
import appSlice from './slices/appSlice';
import patientSlice from './slices/patient/patientSlice';
import calanderSlice from './slices/scheduler/calendarSlice';
import summarySlice from './slices/scheduler/summarySlice';
import todoSlice from './slices/scheduler/todoSlice';
import counsellingNoteSlice from './slices/Notes/counsellingNoteSlice';
import treatmentPlanSlice from './slices/Notes/treatmentPlanSlice';
import communicationSlice from './slices/communicationSlice';
import referralSlice from './slices/referralSlice';
import customCounsellingOneSlice from './slices/patient/customCounsellingOneSlice';
import customCounsellingTwoSlice from './slices/patient/customCounsellingTwoSlice';
import customCounsellingTenSlice from './slices/patient/customCounsellingTenSlice';
import customCounsellingNineSlice from './slices/patient/customCounsellingNineSlice';
import customCounsellingEightSlice from './slices/patient/customCounsellingEightSlice';
import customCounsellingSevenSlice from './slices/patient/customCounsellingSevenSlice';
import customCounsellingSixSlice from './slices/patient/customCounsellingSixSlice';
import customCounsellingFiveSlice from './slices/patient/customCounsellingFiveSlice';
import customCounsellingFourSlice from './slices/patient/customCounsellingFourSlice';
import customCounsellingThreeSlice from './slices/patient/customCounsellingThreeSlice';
// Combine reducers
const appReducer = combineReducers({
  app: appSlice,
  auth: authSlice,
  patient: patientSlice,
  appointment: appointmentSlice,
  calander: calanderSlice,
  summary: summarySlice,
  todo: todoSlice,
  counsellingNote: counsellingNoteSlice,
  treatmentPlan: treatmentPlanSlice,
  communication: communicationSlice,
  referral: referralSlice,
  customCounsellingOne: customCounsellingOneSlice,
  customCounsellingTwo: customCounsellingTwoSlice,
  customCounsellingThree: customCounsellingThreeSlice,
  customCounsellingFour: customCounsellingFourSlice,
  customCounsellingFive: customCounsellingFiveSlice,
  customCounsellingSix: customCounsellingSixSlice,
  customCounsellingSeven: customCounsellingSevenSlice,
  customCounsellingEight: customCounsellingEightSlice,
  customCounsellingNine: customCounsellingNineSlice,
  customCounsellingTen: customCounsellingTenSlice,
});

// Root reducer with state reset on logout
const reducer = (state, action) => {
  if (action.type === 'auth/logout') {
    state = undefined; // Clear all state
  }
  return appReducer(state, action);
};

export default reducer;
